import { Pipe, PipeTransform } from "@angular/core";
import { Node } from "src/app/models";

@Pipe({
    name: "orgUnitTree",
    pure: true,
    standalone: true,
})
export class OrgUnitTreePipe implements PipeTransform {
    transform(nodes: Node[] | null | undefined, type: "all" | "ops" | "cs"): Node[] {
        if (!nodes) return [];
        if (type === "all") return nodes;

        return nodes.map(
            root => ({ ...root, children: this._collectMatches(root.children ?? [], type) })
        ).filter(x => x.children.length !== 0);
    }

    private _collectMatches(nodes: Node[], type: string): Node[] {
        const matches: Node[] = [];

        const collect = (node: Node): void => {
            const match = type === "cs"
                ? node.orgUnit.typeId !== "Destinacija" : node.orgUnit.typeId === "Destinacija";
            if (match) {
                matches.push(node);
                return;
            }
            for (const child of node.children ?? []) {
                collect(child);
            }
        };

        for (const node of nodes) {
            collect(node);
        }

        return matches;
    }
}
